export enum IgnoreMLPathReasonEnum {
  WaypointsModified = "WaypointsModified",
  UserDecision = "UserDecision",
}
